import { useAnalyticsLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/AnalyticsLinks";
import { useBrandedAppsDashboardLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/BrandedAppsDashboardLinks";
import { useCommunityBotLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/CommunityBotLinks";
import { useContentLinksWithoutModerationBadge } from "@circle-react-shared/SettingsNav/NestedNavBar/ContentLinks";
import { useCoursesLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/CoursesLinks";
import { useDevelopersLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/DevelopersLinks";
import { useEmailLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/EmailLinks";
import { useMemberLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/MemberLinks";
import { useNewsletterLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/NewsletterLinks";
import { usePaywallLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/PaywallLinks";
import { usePaywallsAffiliatesLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/PaywallsAffiliatesLinks";
import { usePlansLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/PlansLinks";
import { useSettingsLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/SettingsLinks";
import { useSiteLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/SiteLinks";
import type { Link } from "@circle-react-shared/SettingsNav/NestedNavBar/types";
import { useWorkflowLinks } from "@circle-react-shared/SettingsNav/NestedNavBar/WorkflowLinks";
export interface SettingsNavLinks {
  affiliates: Link[];
  analytics_v2: Link[];
  community_bot: Link[];
  content: Link[];
  courses: Link[];
  developers: Link[];
  email: Link[];
  members: Link[];
  newsletter: Link[];
  paywalls: Link[];
  plans: Link[];
  plus: Link[];
  settings: Link[];
  site: Link[];
  workflows: Link[];
}

/**
 * Resolves every settings-nav leaf-link hook exactly once. Both the dock's
 * Build groups (`buildSettingsNavSubItems`) and Settings groups
 * (`buildSettingsNavItems`) derive from this single result, so consumers that
 * need both (e.g. `useBuildNavItems`) don't invoke the shared leaf hooks twice.
 */
export const useSettingsNavLinks = (): SettingsNavLinks => ({
  members: useMemberLinks(),
  content: useContentLinksWithoutModerationBadge(),
  email: useEmailLinks(),
  newsletter: useNewsletterLinks(),
  courses: useCoursesLinks(),
  workflows: useWorkflowLinks(),
  // The community setting still gates the AI agents link; only the
  // `?ff_analytics_ai_agents` QA URL override (read via router search in the
  // AnalyticsLinks component) is intentionally not wired into the dock.
  analytics_v2: useAnalyticsLinks(),
  community_bot: useCommunityBotLinks(),
  paywalls: usePaywallLinks(),
  affiliates: usePaywallsAffiliatesLinks(),
  plans: usePlansLinks().links,
  plus: useBrandedAppsDashboardLinks(),
  site: useSiteLinks(),
  developers: useDevelopersLinks(),
  settings: useSettingsLinks(),
});
